import { initialsFromName, pickAvatarColor } from '../lib/avatarColors';
import clsx from 'clsx';

interface Props {
  name: string;
  color?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function ProfileAvatar({ name, color, size = 'md', className }: Props) {
  const bg = color ?? pickAvatarColor(name);
  const initials = initialsFromName(name);
  const sizeCls =
    size === 'lg'
      ? 'h-14 w-14 text-lg'
      : size === 'sm'
        ? 'h-9 w-9 text-xs'
        : 'h-11 w-11 text-sm';
  return (
    <div
      className={clsx(
        'flex items-center justify-center rounded-full font-semibold text-white shrink-0',
        sizeCls,
        className,
      )}
      style={{ background: bg }}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
